import { RatingType } from "~/types/shop/RatingType";

export const RatingEntity = function (data: any): RatingType {
    return {
        title: data?.title,
        rating: Number(data?.rating),
    };
};